import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { factoryItemsSchemaObject } from '../../Data'
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi, { x } from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { operationEntityConfigurationSchema } from '../operationEntityConfigurationSchema';
import { MultiSelect } from "../../../Common/multiSelect";

const screenCode = 'OPERATIONENTITYCONFIGURATION';

export function OperationEntityConfigurationAddEdit(props) {

    const [selectedOptions, setSelectedOptions] = useState([]);
    const getOptionLabel = option => `${option.label}`;
    const getOptionDisabled = option => option.value === "foo";
    const handleToggleOption = selectedOptions =>
        setSelectedOptions(selectedOptions);
    const handleClearOptions = () => setSelectedOptions([]);
    const handleSelectAll = isSelected => {
        if (isSelected) {
            setSelectedOptions(collectionPoints);
        } else {
            handleClearOptions();
        }
    };

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Operation Entity Configuration")
    const [groups, setGroups] = useState()
    const [collectionPoints, setCollectionPoints] = useState()
    const [configurationName, setConfigurationName] = useState()
    const [factories, setFactories] = useState()
    const [collectionPointList, setCollectionPointList] = useState()
    const [factoryItems, setFactoryItems] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        configurationName: 0,
        configurationValue: 0,
        measuringUnit: 0,
        minValue: 0,
        maxValue: 0,
        JsonString:"",
        isApply: false,
        isActive: true,
        configurationTypeID: 0,
        collectionPointName: "",
        configID: 0,
        mapID: 0
    });
    const [collectionPoint, setCollectionPoint] = useState()
    const [buttonName, setButtonName] = useState("Save")
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [isEditing, setIsEditing] = useState(false);
    const [pageProperties, setPageProperties] = useState({
        btnEnabled: true,
        dropDownDisabled: false,
        fieldsDisabled: false
    });
    const [editedCodes, setEditedCodes] = useState({
        codes: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(operationEntityConfigurationSchema).options({ allowUnknown: true })

    useEffect(() => {
        trackPromise(
            setGroupDropDownData(),
            setConfigurationNamesDropDownData(),
        )

        if (data && edit) {
            setTitle("Edit Operation Entity Configuration");
            setFactoryItems(data);

            FactoryByGroupEntity(data.groupID);
            setButtonName("Update")
        } else {
            setTitle("Add Operation Entity Configuration")
        }

    }, [])

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(FactoryByGroupEntity(factoryItems.groupID))
    }, [factoryItems.groupID]);

    useEffect(() => {
        if (factoryItems.groupID !== 0 && factoryItems.operationEntityID !== 0) {
            trackPromise(
                setConfigurationNamesDropDownData(),
            );
        }

    }, [factoryItems.operationEntityID]);

    useEffect(() => {
        trackPromise(setCollectionPointsDropDownData())
    }, [factoryItems.configurationName]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITOPERATIONENTITYCONFIGURATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });
        if (data && edit) {
            setTitle("Edit Operation Entity Configuration");
            setFactoryItems(data);
            setButtonName("Update");
        } else {
            setTitle("Add Operation Entity Configuration");
            var token = tokenService.getUserDetailsFromToken();
            setFactoryItems({
                ...factoryItems,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            })
        }
        setGroupDropDownData()
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function setConfigurationNamesDropDownData() {
        const result = await services.getConfigurationNames(factoryItems.operationEntityID)
        setConfigurationName(result)
    }

    async function setCollectionPointsDropDownData() {
        let filteredData = await services.GetMultipleCollectionPoints(
            factoryItems.operationEntityID,
            configurationName[factoryItems.configurationName]
        );
        var options = []
        for (let item of Object.entries(filteredData)) {
            options.push({ label: item[1]["collectionPointName"], value: item[1]["collectionPointID"] });
        }
        setCollectionPoints(options);
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'isApply' ? target.checked : target.value
        const error = { ...errors }
        const errorMessage = validateProperty(target, operationEntityConfigurationSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value
        })
        setErrors(error)
    }

    function handleGroupChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value
        const error = { ...errors }
        const errorMessage = validateProperty(target, operationEntityConfigurationSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value,
            operationEntityID: 0
        })
        trackPromise(
            FactoryByGroupEntity(value)
        )
        setErrors(error)
    }

    function handleOperationEntityChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, operationEntityConfigurationSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value
        })
    }

    async function getCollectionPointIDForDropdown() {
        const collectionPoint = await services.GetCollectionPointsFilter(factoryItems.operationEntityID);
        setCollectionPoint(collectionPoint);
    }
    async function getCollectionPointList() {
        var collectionPointID = (data === undefined ? 0 : data.collectionPointID);
        var options = [];
        const collectionPoint = await services.GetAllCollectionPoints(factoryItems.operationEntityID, collectionPointID);
        collectionPoint.forEach(x => {
            let collectionPoint = { label: x.collectionPointID }
            options.push(collectionPoint)

        });

        setCollectionPointList(options);
    }

    async function getCollectionPointDropDownItems() {
        var collectionPointID = (data === undefined ? 0 : data.collectionPointID);
        const dataArray = [];
        const collectionPoint = await services.GetAllCollectionPoints(factoryItems.operationEntityID, collectionPointID);
        for (let item of Object.entries(collectionPoint)) {
            dataArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
        setCollectionPoints(dataArray);
    }

    function handleChange1(e) {
        const target = e.target;
        const value = target.name === 'isApply' ? target.checked : target.value
        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value
        });
    }

    function handleChange2(e) {
        const target = e.target;
        const value = target.name === 'isActive' ? target.checked : target.value;
        setFactoryItems({
            ...factoryItems,
            [e.target.name]: value
        });
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);
        setFactoryItems({
            ...factoryItems,
            collectionPointID: target.value,
        });
    }

    async function FactoryByGroupEntity(groupId) {
        if (groupId > 0) {
            let filteredData = await services.getOperationalEntityByGroupEntityID(groupId);
            setFactories(filteredData)
        }
        else {
            setFactories([])
        }
    }

    async function handleSave(e) {
        e.preventDefault()

        let data = {
            groupID: factoryItems.groupID,
            operationEntityID: factoryItems.operationEntityID,
            collectionPointID: factoryItems.collectionPointID,
            configurationName: configurationName[factoryItems.configurationName],
            configurationValue: factoryItems.configurationValue,
            measuringUnit: factoryItems.measuringUnit,
            minValue: factoryItems.minValue,
            maxValue: factoryItems.maxValue,
            JsonString: factoryItems.JsonString,
            isApply: factoryItems.isApply,
            configID: factoryItems.configID,
            mapID: factoryItems.mapID,
            isActive: factoryItems.isActive,
            configurationTypeID: factoryItems.configurationTypeID,
            collectionPointList: selectedOptions,
        };

 
        if (!edit) {
            const response = await services.saveOperationEntityConfiguration(data)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const response = await services.editData(data)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function afterSuccessfulyChanged(response, factoryItems) {
        if (response === "Success") {
            clearState();
            setTimeout(() => {
                props.history.push({ pathname: '/operationEntityConfiguration' })
            }, 1500);
        }
    }

    function clearState() {
        setFactoryItems({
            ...factoryItems,
            groupID: 0,
            operationEntityID: 0,
            collectionPointID: 0,
            configurationName: 0,
            configurationValue: 0,
            measuringUnit: 0,
            minValue: 0,
            maxValue: 0,
            JsonString: 0,
            isApply: false,
            isActive: true,
            configurationTypeID: 0,
            collectionPointList: 0

        })
    }

    function clearButton() {
        setErrors({});
        if (edit) {
            setFactoryItems(data);
        } else {
            setFactoryItems({
                ...factoryItems,
                groupID: 0,
                operationEntityID: 0,
                collectionPointID: 0,
                configurationName: 0,
                configurationValue: 0,
                measuringUnit: 0,
                minValue: 0,
                maxValue: 0,
                JsonString: 0,
                isApply: false,
                isActive: true,
                configurationTypeID: 0,
                collectionPointList: 0
            })
        }

    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function validateInputs(target) {
        const error = { ...errors }
        const errorMessage = validateProperty(target, operationEntityConfigurationSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setErrors(error);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/operationEntityConfiguration"
                        />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group Name *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={factoryItems.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled || edit}
                                            onChange={(e) => handleGroupChange(e)}>
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={factoryItems.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled || edit}
                                            onChange={(e) => handleOperationEntityChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1" hidden={edit}>
                                        <InputLabel shrink id="configurationName">Configuration *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="configurationName"
                                            name="configurationName"
                                            value={factoryItems.configurationName}
                                            disabled={edit}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Configuration--</MenuItem>
                                            {generateDropDownMenu(configurationName)}
                                        </Select>
                                        {errors["configurationName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["configurationName"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1" hidden={!edit}>
                                        <InputLabel shrink id="configurationName">Configuration *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="configurationName"
                                            name="configurationName"
                                            value={factoryItems.configName}
                                            disabled={edit}
                                            onChange={(e) => handleChange(e)} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1" hidden={edit}>
                                        <MultiSelect
                                            items={collectionPoints}
                                            getOptionLabel={getOptionLabel}
                                            getOptionDisabled={getOptionDisabled}
                                            selectedValues={selectedOptions}
                                            disabled={edit}
                                            label="Select Available Collection Points"
                                            placeholder="Collection Points"
                                            selectAllLabel="Select all"
                                            onToggleOption={handleToggleOption}
                                            onClearOptions={handleClearOptions}
                                            onSelectAll={handleSelectAll}
                                        />
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1" hidden={!edit}>
                                        <InputLabel shrink id="collectionPointName">Collection Point</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="collectionPointName"
                                            name="collectionPointName"
                                            value={factoryItems.collectionPointName}
                                            disabled={edit}
                                            onChange={(e) => handleChange(e)} />
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="configurationTypeID">Configuration Type</InputLabel>
                                        <Select
                                            fullWidth
                                            id="configurationTypeID"
                                            name="configurationTypeID"
                                            value={factoryItems.configurationTypeID}
                                            onChange={(e) => handleChange1(e)}>
                                            <MenuItem value="0">--Select Configuration Type--</MenuItem>
                                            <MenuItem value="1">Value</MenuItem>
                                            <MenuItem value="2">Min Max</MenuItem>
                                            <MenuItem value="3">Boolean</MenuItem>
                                        </Select>
                                        {errors["configurationTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["configurationTypeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="configurationValue">Configuration Value</InputLabel>
                                        <TextField
                                            fullWidth
                                            name="configurationValue"
                                            id="configurationValue"
                                            type="text"
                                            value={factoryItems.configurationValue}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["configurationValue"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["configurationValue"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="measuringUnit">Measuring Unit</InputLabel>
                                        <Select
                                            fullWidth
                                            id="measuringUnit"
                                            name="measuringUnit"
                                            value={factoryItems.measuringUnit}
                                            onChange={(e) => handleChange1(e)}>
                                            <MenuItem value="0">--Select Measuring Unit--</MenuItem>
                                            <MenuItem value="1">Kg</MenuItem>
                                            <MenuItem value="2">Litre</MenuItem>
                                            <MenuItem value="3">Unit</MenuItem>
                                        </Select>
                                        {errors["measuringUnit"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["measuringUnit"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="minValue">Min Value</InputLabel>
                                        <TextField
                                            fullWidth
                                            name="minValue"
                                            id="minValue"
                                            type="text"
                                            value={factoryItems.minValue}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["minValue"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["minValue"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="maxValue">Max Value</InputLabel>
                                        <TextField
                                            fullWidth
                                            name="maxValue"
                                            id="maxValue"
                                            type="text"
                                            value={factoryItems.maxValue}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["maxValue"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["maxValue"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="JsonString">Json String</InputLabel>
                                        <TextField
                                            fullWidth
                                            name="JsonString"
                                            id="JsonString"
                                            type="text"
                                            value={factoryItems.JsonString}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["JsonString"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["JsonString"]}</FormHelperText>}
                                    </div>
                                </div>
                                <label>Is Apply</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            id="isApply"
                                            switch="none"
                                            className="mr-2"
                                            type="checkbox"
                                            name="isApply"
                                            onChange={(e) => handleChange(e)}
                                            checked={factoryItems.isApply}
                                        />
                                        <label htmlFor="isApply" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                                <label>Active</label>
                                <div className="form-group row">
                                    <div className="col-md ">
                                        <input
                                            id="isActive"
                                            switch="none"
                                            className="mr-2"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleChange2(e)}
                                            checked={factoryItems.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value={buttonName}
                                    onClick={handleSave}
                                />
                                <input type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={clearButton}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}